module.exports = __webpack_public_path__ + "media/src/images/icons/fill-arrow-up-f01ebc6d174f88654180e84504614f86.svg";